module.exports = __webpack_public_path__ + "img/tree.97b2ae27.png";